import { useState } from "react";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";

export const Tratament = () => {
  const [isOpenAcolhida, setIsOpenAcolhida] = useState(false);
  const [isOpenPeriodo, setIsOpenPeriodo] = useState(false);
  const [isOpenPilares, setIsOpenPilares] = useState(false);
  const [isOpenModalidades, setIsOpenModalidades] = useState(false);
  const [isOpenInstrumentos, setIsOpenInstrumentos] = useState(false);

  const toggleAcolhida = () => {
    setIsOpenAcolhida(!isOpenAcolhida);
  };

  const togglePeriodo = () => {
    setIsOpenPeriodo(!isOpenPeriodo);
  };

  const togglePilares = () => {
    setIsOpenPilares(!isOpenPilares);
  };

  const toggleModalidades = () => {
    setIsOpenModalidades(!isOpenModalidades);
  };

  const toggleInstrumentos = () => {
    setIsOpenInstrumentos(!isOpenInstrumentos);
  };

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            TRATAMENTO
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Programa terapêutico completo focado no resgate da autonomia e
            cidadania.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      <div className="tratament-container">
        {/* Program Overview */}
        <section className="py-20 bg-white text-brand-blue">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
                Programa Terapêutico CT PATRE Cristo Rei
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-brand-blue to-brand-yellow mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-3xl shadow-xl">
                <p className="text-lg font-roboto text-gray-700 leading-relaxed mb-6">
                  O Programa Terapêutico é baseado no modelo de intervenção
                  psicossocial com foco no indivíduo, em sua
                  existência-sofrimento, resgate da autonomia e cidadania,
                  combate ao estigma e preconceito e a efetivação de um cuidado
                  em saúde alinhado a defesa dos direitos humanos.
                </p>
                <p className="text-lg font-roboto text-gray-700 leading-relaxed">
                  Nesse Programa, todos os indivíduos participam ativamente,
                  colaborando uns com os outros, partilhando informações,
                  servindo de modelos, estabelecendo um sistema de normas e
                  valores definidos e uma comunicação aberta nos relacionamentos
                  individuais e grupais.
                </p>
              </div>

              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-8 rounded-3xl shadow-xl">
                <h3 className="text-3xl font-bold font-montserrat mb-6 text-brand-blue">
                  Nossa Abordagem
                </h3>
                <p className="text-lg font-roboto text-gray-700 leading-relaxed">
                  Trabalhamos com uma visão holística do tratamento,
                  considerando não apenas a dependência química, mas também os
                  aspectos emocionais, sociais e espirituais de cada indivíduo.
                  Nosso compromisso é oferecer um ambiente seguro e acolhedor
                  para a transformação completa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Treatment Details Sections */}
        <section className="py-20 bg-gradient-to-r from-slate-800 to-slate-900">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-5xl font-bold text-center font-montserrat mb-16 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
              Detalhes do Tratamento
            </h2>

            {/* Acolhida Section */}
            <div className="mb-8">
              <div
                className="bg-gradient-to-r from-brand-blue/20 to-transparent p-8 rounded-3xl border border-brand-blue/30 hover:border-brand-yellow/50 transition-all duration-500 cursor-pointer group"
                onClick={toggleAcolhida}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-3xl font-bold font-montserrat text-white group-hover:text-brand-yellow transition-colors duration-300">
                    ACOLHIDA
                  </h3>
                  <div className="text-2xl text-brand-yellow group-hover:scale-110 transition-transform duration-300">
                    {isOpenAcolhida ? <BsArrowUp /> : <BsArrowDown />}
                  </div>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  isOpenAcolhida
                    ? "max-h-96 opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20">
                  <p className="text-lg font-roboto text-gray-300 leading-relaxed mb-4">
                    A acolhida se dá desde o primeiro contato, sendo informado
                    por um profissional acerca do programa, até seu
                    encaminhamento para o início do tratamento.
                  </p>
                  <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                    Entre em contato pelo fone/whats 54 99699-8885 / 54 99930.
                    2788
                  </p>
                </div>
              </div>
            </div>

            {/* Período do Tratamento Section */}
            <div className="mb-8">
              <div
                className="bg-gradient-to-r from-brand-yellow/20 to-transparent p-8 rounded-3xl border border-brand-yellow/30 hover:border-brand-blue/50 transition-all duration-500 cursor-pointer group"
                onClick={togglePeriodo}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-3xl font-bold font-montserrat text-white group-hover:text-brand-blue transition-colors duration-300">
                    PERÍODO DO TRATAMENTO
                  </h3>
                  <div className="text-2xl text-brand-blue group-hover:scale-110 transition-transform duration-300">
                    {isOpenPeriodo ? <BsArrowUp /> : <BsArrowDown />}
                  </div>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  isOpenPeriodo
                    ? "max-h-[800px] opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20">
                  <p className="text-lg font-roboto text-gray-300 leading-relaxed mb-6">
                    O programa de tratamento da Comunidade Terapêutica PATRE tem
                    uma duração recomendada de 09 (nove) a 12 (doze) meses, pois
                    acreditamos que esse período é essencial para permitir que
                    nossos acolhidos desenvolvam habilidades, ferramentas e
                    recursos sólidos para superar a dependência e se manterem
                    saudáveis e positivos no longo prazo.
                  </p>
                  <p className="text-lg font-roboto text-gray-300 leading-relaxed mb-6">
                    Dentro deste período de tempo, algumas etapas estão
                    previstas, sendo elas:
                  </p>
                  <div className="space-y-3 text-gray-300">
                    <p className="font-semibold">
                      1. Desintoxicação e adaptação (0º mês ao 3º mês);
                    </p>
                    <p className="font-semibold">
                      2. Conscientização e reformulação (3º mês ao 6º mês);
                    </p>
                    <p className="font-semibold">
                      3. Reinserção social (6º mês ao 9º mês);
                    </p>
                    <p className="font-semibold">
                      4. Reforço (9º mês ao 12º mês), se necessário.
                    </p>
                  </div>
                  <p className="text-lg font-roboto text-gray-300 leading-relaxed mt-6">
                    É importante ressaltar que a duração do tratamento pode
                    variar de acordo com as necessidades individuais de cada
                    paciente, e que nossa equipe trabalha em conjunto com os
                    acolhidos para avaliar regularmente o progresso e ajustar o
                    plano de tratamento de acordo com as necessidades
                    individuais.
                  </p>
                </div>
              </div>
            </div>

            {/* Pilares do Tratamento Section */}
            <div className="mb-8">
              <div
                className="bg-gradient-to-r from-slate-700/50 to-transparent p-8 rounded-3xl border border-slate-600 hover:border-brand-yellow/50 transition-all duration-500 cursor-pointer group"
                onClick={togglePilares}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-3xl font-bold font-montserrat text-white group-hover:text-brand-yellow transition-colors duration-300">
                    PILARES DO TRATAMENTO
                  </h3>
                  <div className="text-2xl text-brand-yellow group-hover:scale-110 transition-transform duration-300">
                    {isOpenPilares ? <BsArrowUp /> : <BsArrowDown />}
                  </div>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  isOpenPilares
                    ? "max-h-[1200px] opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 space-y-8">
                  <div>
                    <h4 className="text-2xl font-bold font-montserrat text-brand-yellow mb-4">
                      Espiritualidade
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      A importância da dimensão espiritual e da fé é reconhecida
                      como necessária na vida dos seres humanos. No contexto da
                      dependência química, este quesito é primordial. A fé no
                      poder superior serve de alicerce em busca de um sentido
                      maior para a vida. Dentro da comunidade terapêutica é
                      respeitado a individualidade de crenças, entendendo a
                      singularidade de cada indivíduo a partir de sua história
                      de vida. Deste modo, a instituição propicia despertar o
                      interesse pela fé através de textos, dinâmicas e
                      reflexões, compreendendo que a busca se dá a partir de
                      estímulos podendo promover o desejo do indivíduo.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-2xl font-bold font-montserrat text-brand-yellow mb-4">
                      Trabalho (atividade prática inclusiva)
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      O principal fundamento da atividade prática inclusiva é
                      promover o sentimento de pertencimento ao indivíduo,
                      ampliando a consciência da importância de cuidar do local
                      onde vive, retomando o senso de organização, que por vezes
                      encontra-se perdido.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-2xl font-bold font-montserrat text-brand-yellow mb-4">
                      Disciplina
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      São promovidas situações onde o acolhido pode desenvolver
                      o senso de organização de um modo amplo. Neste sentido, a
                      disciplina tem como objetivo principal contribuir para um
                      modo de vida mais saudável. Compreende-se que o
                      aprendizado ocorre através dos hábitos diários e a
                      repetição dos mesmos, estes dentro da comunidade se
                      caracterizam por: a manutenção da higiene pessoal que traz
                      à tona um olhar mais saudável para si, o modo como
                      organiza sua cama e seus pertences pessoais são
                      demonstrações de evolução da disciplina dentro do
                      tratamento.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Modalidades de Atendimento Section */}
            <div className="mb-8">
              <div
                className="bg-gradient-to-r from-brand-blue/20 to-transparent p-8 rounded-3xl border border-brand-blue/30 hover:border-brand-yellow/50 transition-all duration-500 cursor-pointer group"
                onClick={toggleModalidades}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-3xl font-bold font-montserrat text-white group-hover:text-brand-yellow transition-colors duration-300">
                    MODALIDADES DE ATENDIMENTO
                  </h3>
                  <div className="text-2xl text-brand-yellow group-hover:scale-110 transition-transform duration-300">
                    {isOpenModalidades ? <BsArrowUp /> : <BsArrowDown />}
                  </div>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  isOpenModalidades
                    ? "max-h-[1500px] opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 space-y-6">
                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-brand-blue mb-3">
                      Atendimento Psicológico Individual
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      É oferecido atendimento psicológico individual semanal
                      para os acolhidos com o objetivo de acolher e avaliar suas
                      dificuldades e traumas, tendo assim condição de criar
                      vínculos saudáveis, melhorar sua autoestima, desenvolver
                      autonomia, favorecendo o seu desenvolvimento pessoal.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-brand-blue mb-3">
                      Psiquiátrico/Medicamentoso
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Realizado sempre que necessário, através da vinculação com
                      a rede pública de Saúde do município, ou quando possível,
                      por planos médicos ou particular.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-brand-blue mb-3">
                      Orientação Individual
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      A orientação individualizada acontece constantemente, por
                      considerar que todas as intervenções de diferentes áreas
                      se voltam ao cuidado do acolhido na qualidade do
                      tratamento. Em especial, os monitores possuem o papel
                      constante de orientar de forma individualizada os
                      acolhidos, na coletividade do grupo, um olhar singular a
                      cada sujeito. Quando necessário, toda a equipe escuta o
                      acolhido individualmente, sinalizando e orientando nas
                      diversas situações, para uma maior evolução no seu
                      tratamento.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-brand-blue mb-3">
                      Atendimento Social
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Quando o acolhido chega a comunidade é analisado toda a
                      documentação e são avaliadas ações de prevenção,
                      tratamento, socialização e inserção do indivíduo e de sua
                      família junto as políticas sociais e a rede de serviços na
                      perspectiva de qualidade de vida.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-brand-blue mb-3">
                      Atendimento à família
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      A família do acolhido é atendida, em especial, através das
                      reuniões que acontecem na sede da Entidade, reuniões
                      on-line para familiares de outras cidades e também nos
                      dias de visita de familiares, onde a equipe se divide e
                      faz os atendimentos as famílias. Trata-se de um trabalho
                      importante, uma vez que a rede familiar é um dos eixos de
                      sustentação do tratamento e o resgate de vínculos e a
                      conscientização da família é de suma importância para a
                      efetiva qualidade do tratamento.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Instrumentos Terapêuticos Section */}
            <div className="mb-8">
              <div
                className="bg-gradient-to-r from-brand-yellow/20 to-transparent p-8 rounded-3xl border border-brand-yellow/30 hover:border-brand-blue/50 transition-all duration-500 cursor-pointer group"
                onClick={toggleInstrumentos}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-3xl font-bold font-montserrat text-white group-hover:text-brand-blue transition-colors duration-300">
                    INSTRUMENTOS TERAPÊUTICOS
                  </h3>
                  <div className="text-2xl text-brand-blue group-hover:scale-110 transition-transform duration-300">
                    {isOpenInstrumentos ? <BsArrowUp /> : <BsArrowDown />}
                  </div>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-700 ease-in-out ${
                  isOpenInstrumentos
                    ? "max-h-[2500px] opacity-100 mt-4"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 space-y-6">
                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de 12 Passos
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Esta reunião tem como objetivo iniciar um processo de
                      mudança no campo espiritual, emocional e comportamental
                      através do entendimento e reconhecimento do processo de
                      recuperação. Este grupo interfere gradativamente na
                      relação do acolhido com seus próprios sentimentos,
                      ajudando a amenizá-los, trabalhá-los e resolvê-los,
                      podendo assim levar a uma vida tranquila e produtiva.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de Amor Exigente
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Tem como objetivo a revisão de sua escala de valores,
                      entendimento e prática dos mesmos em sua vida, através da
                      utilização da metodologia do Amor Exigente.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Espiritualidade
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Se oportuniza diariamente e também semanalmente por um
                      voluntário junto aos acolhidos, um momento de
                      espiritualidade onde se desenvolve estudos, leituras e
                      cantos espirituais.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de NATA (Núcleo de Apoio ao Toxicômano e
                      Alcoólatra)
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Neste grupo busca-se a expressão do sentimento, auto
                      avaliação, apoio mútuo, estudo do tratamento e
                      consequências da dependência química.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de Prevenção à Recaída
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Tem como foco a conscientização de cada acolhido em suas
                      particularidades sobre os fatores que podem levá-lo a uma
                      recaída, é utilizado de textos que contribuam para a
                      discussão.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião Matinal
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Este grupo configura-se em um espaço dedicado a uma
                      revisão objetiva da vida da Comunidade Terapêutica, onde
                      se trabalha a honestidade e a cultura, indo de encontro
                      com os principais objetivos da CT.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Grupo Filhos de Deus
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Grupo semanal com uma hora de duração, visa a
                      conscientização e aprofundamento espiritual espontâneo.
                      Com momentos de perdão, agradecimento e cânticos de
                      louvores.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de PTS
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Mensalmente a equipe técnica se reúne e seleciona temas,
                      assuntos e vídeos específicos, conforme o momento, para
                      cada acolhido se inteirar e entender mais sobre suas
                      dificuldades específicas.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de 1º Grupo
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Reunião semanal, realizada com os acolhidos que estão nos
                      três primeiros meses de tratamento. É uma reunião mais
                      acolhedora, realizado por uma psicóloga, tendo como
                      objetivo trabalhar o período de adaptação, suas ansiedades
                      e desejos de mudanças, podendo se reconhecer no
                      tratamento.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de 2º Grupo
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Reunião semanal, coordenada por um monitor, com os
                      acolhidos que entram no 3º mês de tratamento até sua
                      primeira reinserção social. Tem como objetivo à
                      conscientização do processo de recuperação, avaliando seus
                      comportamentos a serem modificados orientando de forma
                      singular.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Reunião de 3º Grupo – APROVE
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Grupo realizado a partir da primeira reinserção social,
                      tem como objetivo principal dar direcionamento
                      pós-tratamento. Nessa reunião é entregue o APROVE –
                      "Projeto de Vida", onde os acolhidos analisam os aspectos
                      de suas vidas realizando um planejamento de curto, médio e
                      longo prazo, com orientação dos membros da equipe.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Grupo Operativo
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Visa através de técnicas e dinâmicas o reconhecimento de
                      fraquezas, anseios, expectativas, frustrações no sentido
                      do autoconhecimento, propiciando o desejo pelo novo.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Atividade Prática Inclusiva
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Ocorre diariamente sob a supervisão do monitor e tem como
                      objetivo o desenvolvimento interior do acolhido, a
                      reestruturação de horários, princípios e cuidados com
                      higiene, limpeza a serem seguidos por toda a vida. Existe
                      uma escala de setores, que é modificada semanalmente, onde
                      cada acolhido tem a chance de participar de todos os
                      afazeres da vida comunitária.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Oficina de Artes
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      A atividade é considerada, neste processo, como um
                      instrumento de resgate de habilidades, viabilizando a
                      expressão, a espontaneidade, o conhecimento das
                      potencialidades e das limitações.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-xl font-bold font-montserrat text-yellow-300 mb-3 underline">
                      Atividades Recreativas
                    </h4>
                    <p className="text-lg font-roboto text-gray-300 leading-relaxed">
                      Acreditamos ser muito importante para a formação de
                      vínculos e para mostrar aos acolhidos o lado bom da vida
                      sem o uso de drogas. Dentre as atividades, temos: Futebol,
                      Voleibol, Ping-pong, Dinâmicas, Videoterapia, entre muitas
                      outras. A comunidade também participa do Torneio da
                      Sobriedade, que ocorre a cada 4 meses em uma comunidade
                      terapêutica distinta. A PATRE conta com um time de
                      graduados que joga futebol e algumas vezes, é levado os
                      acolhidos mais velhos de tratamento para participar do
                      mesmo, sempre acompanhados por membos da equipe. São três
                      dias de encontro, onde há espiritualidade, companheirismo,
                      jogos, entretenimento e diversão.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
          <div className="max-w-5xl mx-auto text-center px-4">
            <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
              Pronto para Começar sua Jornada?
            </h2>
            <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
              Entre em contato conosco e dê o primeiro passo rumo à recuperação
              e à transformação.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
              >
                Tratamento
              </a>
              <a
                href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
              >
                Falar com Especialista
              </a>
            </div>
          </div>
        </section>

        {/* Back to Top Button */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
          aria-label="Voltar ao topo"
        >
          <svg
            className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 10l7-7m0 0l7 7m-7-7v18"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
